import * as assignmentsActions from '../actions/assignments.actions';
import { AssignmentApiModel } from 'app/models/assignment-api.model';
import { createReducer, on, Action } from '@ngrx/store';
import * as userActions from '@core/auth/@store/user/user.actions';

export interface State {
  assignments: AssignmentApiModel[];
  totalAssignments: number;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  isReady: false,
  assignments: [],
  totalAssignments: 0,
  isSaving: false,
};

export const featureReducer = createReducer(
  initialState,
  on(
    assignmentsActions.loadAssignmentsSuccess,
    (state: State, { payload }) => ({
      ...state,
      isReady: true,
      assignments: payload.results,
      totalAssignments: payload.count,
    })
  ),
  on(
    assignmentsActions.createAssignment,
    assignmentsActions.updateAssignment,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    assignmentsActions.createAssignmentSuccess,
    assignmentsActions.createAssignmentFailed,
    assignmentsActions.updateAssignmentSuccess,
    assignmentsActions.updateAssignmentFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(userActions.setActiveCompany, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
